import {FC} from 'react'
import capitalize from 'lodash/capitalize'
import {Dropdown} from 'react-bootstrap'
import {globalFilter} from 'app/constant'

const statusTypes = [
  {
    id: 'PICKUP',
    name: 'Pickup',
  },
  {
    id: 'SHIP',
    name: 'Ship',
  },
]

type Props = {
  filter: any
  setFilter: (value: any) => any
}

const OrderDeliveryFilter: FC<Props> = ({filter, setFilter}) => {
  const handleChange = (orderDelivery: any) => {
    let deliveryStatus
    if (orderDelivery === '') {
      deliveryStatus = null
    } else {
      deliveryStatus = orderDelivery
    }
    setFilter({...filter, deliveryStatus, offset: 0})
  }

  return (
    <Dropdown>
      <Dropdown.Toggle variant='transparent' className={`${globalFilter.css} px-4 mt-1`}>
        {capitalize(filter.deliveryStatus) || 'Delivery Status'}
      </Dropdown.Toggle>
      <Dropdown.Menu className='form-control border-dark border mt-1 ms-1'>
        <Dropdown.Item eventKey='' as='button' onSelect={handleChange}>
          All
        </Dropdown.Item>
        {statusTypes.map((status) => (
          <Dropdown.Item key={status.id} eventKey={status.id} as='button' onSelect={handleChange}>
            {status.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default OrderDeliveryFilter
